export default __webpack_public_path__ + "media/images/images_v2/double-fleche-new-145d75d59d0846e1074754b0dcfeb579.png";